/**
 * Insider Integration — Identity (CPF normalization + MD5 hashing)
 * Uses crypto-js (same library as ecom.storefront).
 */

import MD5 from 'crypto-js/md5';

/**
 * Normalize a CPF string: remove formatting, keep only digits, ensure 11 chars.
 */
export function normalizeCpf(cpf: string): string {
  const digits = cpf.replace(/\D/g, '');
  if (digits.length !== 11) {
    throw new Error(`Invalid CPF: expected 11 digits, got ${digits.length}`);
  }
  return digits;
}

/**
 * Generate MD5 hash from a normalized CPF string.
 */
export function hashCpf(normalizedCpf: string): string {
  return MD5(normalizedCpf).toString();
}

/**
 * Convenience: normalize + hash in one call.
 */
export async function normalizeCpfAndHash(rawCpf: string): Promise<string> {
  const normalized = normalizeCpf(rawCpf);
  return hashCpf(normalized);
}
